import React from 'react';
import PropTypes from 'prop-types';
import { Card, Icon, Image as SemanticImage } from 'semantic-ui-react';
import classnames from 'classnames';

import { Formatters } from 'Common/Helpers';
import { FALLBACK_IMAGE } from 'Common/Constants';
import { statusToClassMap } from '../../common/constants';

const GroupTeacherProfile = ({
  profile = {},
  onProfileSelect,
  onSelectClick,
  showServingStatus,
}) => {
  const hasImage = Boolean(profile.Picture);
  const selected = profile.selected;
  const hasError = Boolean(profile.error);
  const imageSrc = hasImage
    ? Formatters.prependBase64(profile.Picture)
    : FALLBACK_IMAGE;
  return (
    <Card
      color={hasError ? 'red' : selected ? 'blue' : undefined}
      onClick={() => onSelectClick(profile)}
    >
      <Icon
        className="profile-icon-right"
        float="right"
        name={profile.selected ? 'circle check' : 'circle outline'}
        size="big"
        color={'green'}
      />
      <Icon
        className="profile-icon-left"
        float="right"
        name={'edit'}
        size="big"
        onClick={e => {
          e.stopPropagation();
          onProfileSelect(profile);
        }}
        color={'green'}
      />
      <SemanticImage
        className={`${classnames(
          'group-teacher-card-image',
          showServingStatus && statusToClassMap[profile.StatusCurrent]
        )}`}
        src={imageSrc}
        alt="Profile"
      />
      <Card.Content className="compact">
        <div className="text-primary strong">{profile.FullName}</div>
        <Card.Description>
          Balance: {Formatters.balance(profile.Balance)}
        </Card.Description>
      </Card.Content>
    </Card>
  );
};

GroupTeacherProfile.propTypes = {
  profile: PropTypes.object,
  onProfileSelect: PropTypes.func,
};

export default GroupTeacherProfile;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/groupTeacher/component/GroupTeacherProfile.js